import { types } from 'mobx-state-tree';

const PricingStrategy = types.model('PricingStrategy', {
  breakEven: types.maybe(types.number),
  createdDatetime: types.optional(types.string, ''),
  currency: types.optional(types.string, ''),
  destinationMarketplaceId: types.optional(types.string, ''),
  discoveryId: types.maybe(types.number),
  discoveryItemId: types.maybe(types.number),
  discoveryItemVariationId: types.maybe(types.number),
  id: types.maybe(types.number),
  profitPercent: types.maybe(types.number),
  profitType: types.maybe(types.number),
  profitValue: types.maybe(types.number),
  quantity: types.maybe(types.number),
  salePrice: types.maybe(types.number),
  sellerAccountId: types.maybe(types.string),
  sourcePrice: types.maybe(types.number),
  strategyType: types.maybe(types.number),
  minimalProfitPercentOrUnit: types.maybe(types.number),
  penetrationDownCurrencyUnits: types.maybe(types.number),
  penetrationDownDays: types.maybe(types.number),
  penetrationMaximalProfitPercentOrCurrencyUnits: types.maybe(types.number),
  penetrationUpCurrencyUnits: types.maybe(types.number),
  penetrationUpSalesCount: types.maybe(types.number),
}).actions(self=>({
  increaseQuantity: () => {
    self.quantity += 1;
  },
  decreaseQuantity: () => {
    self.quantity -= 1;
  },
  setProfitType: type => {
    self.profitType = type;
  },
}));

export default PricingStrategy;
